import { useEffect } from 'react';
import { GetPreOnBoardingStepAction } from '../redux/actions/pre-onboarding/preOnboardingActions';
// import { useNavigate } from 'react-router';
import {
    indexPage,
    isGuestAllowed,
} from '../../Routes';
import { useDispatch, useSelector } from 'react-redux';
import {
    GET_PREONBOARDING_STEP,
    PRE_ONBOARDING_PATH_ARR,
} from '../redux/constants/pre-onboarding/pre-onboarding';

const isLocalEnv = process.env.NODE_ENV === 'development';
console.log('isLocalEnv', isLocalEnv);


function CheckPreonboardingStatus() {
    const dispatch = useDispatch();
    const { initGetPreOnBoardingStep } = GetPreOnBoardingStepAction();

    const { UserProfileData } = useSelector(state => state?.GetUserProfileDataReducer)

    useEffect(() => {
        const currentPath = window.location.pathname;
        // if guest route return from this condition;
        let cleanPathname = currentPath;
        console.log('pathIndex-currentPath', currentPath, currentPath.replace(/\/([^/]*)$/, '$1'));
        console.log('pathIndex-cleanPathname',cleanPathname);

        if (cleanPathname.indexOf(process.env.PUBLIC_URL) === 0) {
            cleanPathname = cleanPathname.replace(process.env.PUBLIC_URL, '');
        }
        if (isGuestAllowed(cleanPathname)) {
            dispatch({ type: GET_PREONBOARDING_STEP, payload: 0 });
            return;
        }
        if(!UserProfileData) {
            return;
        }

        // if role is not user we will not redirect to preonboarding step
        const isRegularUser = UserProfileData?.user?.userRoles.includes(0);
        if(!isRegularUser) {
            dispatch({ type: GET_PREONBOARDING_STEP, payload: 1000 });
            return;
        }
        
        initGetPreOnBoardingStep((data) => {
            // in local path will be '/' while in production it will be different
            if(cleanPathname === indexPage || cleanPathname.replace(/\/([^/]*)$/, '$1') === process.env.REACT_APP_FACES_WEB_BASE_URL) {
                // on index page we are navigating differently
                return;
            }
            console.log('data-data-preon', data);
            const completedStep = data?.completedStep;
            if (completedStep < 4) {
                const pathIndex = PRE_ONBOARDING_PATH_ARR.findIndex((item) => cleanPathname.includes(item));
                console.log('pathIndex', pathIndex, `${process.env.REACT_APP_FRONTEND_URL}${PRE_ONBOARDING_PATH_ARR[completedStep + 1]}`);
                if (pathIndex === -1 || pathIndex !== completedStep + 1) {
                    // navigate can only be used inside router component, that's why I used following code instead.
                    // const newUrl = window.location.href.replace(cleanPathname,PRE_ONBOARDING_PATH_ARR[completedStep + 1]);
                    // window.location.replace(newUrl);
                    
                    if(isLocalEnv) {
                        window.location.pathname = PRE_ONBOARDING_PATH_ARR[completedStep + 1];
                    } else {
                        window.location.href = `${process.env.REACT_APP_FRONTEND_URL}${PRE_ONBOARDING_PATH_ARR[completedStep + 1]}`
                    }
                }
            }
        });
    }, [UserProfileData]);

    return null;
}
export default CheckPreonboardingStatus;
